import { utl_parseData, html } from "../base/_utils";
import "bootstrap/js/dist/collapse";
import edgeLineInit from "../components/_edge-line";
import { endowments } from "../data/_endowments-list";
import Papa from "papaparse";
import prependEditDataLink from "../components/_prepend-edit-data-link";

edgeLineInit();

// Render entire table including the generated html from the for loop
function renderTable(dynamicHTML) {
    return html`
        <div class="table-responsive">
            <table class="table table-striped table-bordered">
                <tbody>
                    <tr>
                        <td class="bg-black text-secondary">Year</td>
                        <td class="bg-black text-secondary">Recipient</td>
                    </tr>
                    ${dynamicHTML}
                </tbody>
            </table>
        </div>
    `;
}

// Loop through data and render HTML for each row
function generateTableHTML(tableData) {
    let tableHTML = "";

    for (let i = 0; i < tableData.length; i++) {
        tableHTML += html`
            <tr>
                <td>${tableData[i].year}</td>
                <td>${tableData[i].recipient}</td>
            </tr>
        `;
    }

    return tableHTML;
}

async function getAndDisplayData(dataRef) {
    try {
        // Find the item in endowments that matches the provided dataRef
        const item = endowments.find((entry) => entry.dataRef === dataRef);

        const sheetEditUrl = () => {
            if (item.sport === "all") {
                return "https://docs.google.com/spreadsheets/d/1jNJfhmzsyifAtPeNWBE-qW0XC--vI4cmTwgJV5DlqgM/edit";
            } else if (item.sport === "baseball") {
                return "https://docs.google.com/spreadsheets/d/1kBeQkjhb3yxNg9oj_RRWkrICYmVjshqAVP_fOBbGQ8o/edit";
            } else if (item.sport === "basketball") {
                return "https://docs.google.com/spreadsheets/d/1n6PmK54ItwcTwpoP21PUIlngioKaxGa8hdo6rmyQLGY/edit";
            } else if (item.sport === "football") {
                return "https://docs.google.com/spreadsheets/d/12HO9oTaJiP44ayCIuCwbPIKa4gEKITu1CS7hy18Zrjg/edit";
            } else if (item.sport === "golf") {
                return "https://docs.google.com/spreadsheets/d/1lbc3pVUrBAE9zmzrlKigGKA7IQ0nyxz2AxXzZXc0V9E/edit";
            } else if (item.sport === "gymnastics") {
                return "https://docs.google.com/spreadsheets/d/1I4GjNDrv6UizPlgqvKp4Iehb7om-szDpOElrZ0z3kJE/edit";
            } else if (item.sport === "soccer") {
                return "https://docs.google.com/spreadsheets/d/1ilYDKJDATWFembvjjOMUwH2DqKKgTQCwYy0GJQiLqdo/edit";
            } else if (item.sport === "softball") {
                return "https://docs.google.com/spreadsheets/d/1q2yq41kDrAQHaNUi7TGilcKIRmFbg-4eOzN00bcrZ5o/edit";
            } else if (item.sport === "swim-dive") {
                return "https://docs.google.com/spreadsheets/d/1vGjqxgoUSssMnQ1-M3dsrHmUFAXb_3oYidZgE5OmHns/edit";
            } else if (item.sport === "tennis") {
                return "https://docs.google.com/spreadsheets/d/1plTqsc-aobLANf-MRtnGuC2etJR9q4Mz3OlUX6Vz50o/edit";
            } else if (item.sport === "track-field") {
                return "https://docs.google.com/spreadsheets/d/16_R6ydyGZr2DYkCPJmDEaAXysQ_ZZMzirP8zK7s1-dI/edit";
            } else if (item.sport === "volleyball") {
                return "https://docs.google.com/spreadsheets/d/1GrUQbY6OBdvlEoFSZh9Xww4hhNMpkhp1hF4iN0rl-bg/edit";
            }
        };

        if (!item) {
            console.warn(`No matching item found for dataRef: ${dataRef}`);
            return;
        }

        let results = await utl_parseData(item.data, Papa);
        let data = results.data;
        let tableHTML = generateTableHTML(data);

        item.domEl.innerHTML = renderTable(tableHTML);

        // Scope to this item's own collapse element so each table gets its own edit link
        prependEditDataLink(`#${item.domEl.id} .table-responsive`, item.data, sheetEditUrl());
    } catch (error) {
        console.error("Error parsing data:", error);
    }
}

// Loop over endowments and call getAndDisplayData for each item
endowments.forEach((item) => {
    getAndDisplayData(item.dataRef);
});
